
import React, { ReactNode } from 'react';
import style from './style.module.scss';
import { IProps, IHandlers } from './types';
import {Button, Theme, Tooltip, useTheme} from '@material-ui/core';
import {renderIf} from "app/services/reactUtils.service";
import TagIcon from "external-components/tag-icon/index";
import classNames from 'classnames';
import { FunctionTrackerInfo } from 'app/app.types';
import UtilsService from "app/services/utils/utils.service";

const NS = 'BookingInfo';

export default function BookingInfo({
  bookingRef, tagIcons, displayStartDate, displayEndDate, displayName, isBookingEndTimeInvalid,
  canShowBookingEndTime, displayBookingRef, isCompact, isExpired, isFunctionTrackerBooking, getCustomerInfo
}: IProps & IHandlers) {
  const {palette}: Theme = useTheme();
  const bookingEndTimeSpan: ReactNode = canShowBookingEndTime ? <> - <span style={{color: isBookingEndTimeInvalid && palette.error.dark}}>{displayEndDate}</span> </> : null;

  return (
    <div className={style.root}>
      <span className={classNames({
        [style.text]: true,
        [style.textHasTags]: !!(tagIcons && tagIcons.length)
      })}>
        <span className={style.datetime} style={{
          color: palette.primary.main
        }}>
          {displayStartDate} {bookingEndTimeSpan}
        </span>

        {renderIf(isFunctionTrackerBooking, () =>
          <Tooltip title={FunctionTrackerInfo.name} placement="top">
            <span className={style.functionTrackerIcon}>FT</span>
          </Tooltip>
        )}

        {renderIf(tagIcons, () => (
          <span className={style.tagsWrap}>
            {tagIcons.map((tag, i) => (
              <TagIcon key={`tag-${i}`} {...tag} getCustomerInfo={getCustomerInfo} />
            ))}
          </span>
        ))}

        {/*<br />*/}
        <span className={classNames({
          [style.name]: true,
          [style.nameIsCompact]: isCompact
        })} style={{
          color: isExpired ? palette.error.main : 'rgba(0,0,0,0.87)'
        }}>
          {UtilsService.htmlDecode(displayName, true)}
        </span>
      </span>

      {renderIf(displayBookingRef, () => (
        <span>Booking Ref: {bookingRef}</span>
      ))}
    </div>
  )
}

